/* ------------------------------------------ gfTool 21/05/2017 ----------------------------------------- */
import store from '@/app/store/store';
import { checkKeyValid } from '@/app/utils/checkRoleApply.ts';

(function (jQuery) {
  jQuery.gfTools = function (element, options) {
    const defaults = {};
    this.settings = {};

    const _this = this;

    var $element = jQuery(element),
      element = element;

    let $_targetMER;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();

    (this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      $element.off('mouseover.tool mouseenter.tool').on('mouseover.tool mouseenter.tool', function (e) {
        e.preventDefault();
        if ($gryffEditor.data('gryffeditor').isDragging()) {
          return;
        }
        if (!$gryffEditor.data('gryffeditor').isDragging() && !window._isScrolling) {
          const $target = jQuery(e.target).closest('.gf_row, .module-wrap, .element-wrap');
          if ($target.find('.gf_primary-tool').length > 0) {
            return false;
          }
          if (window._toolTimeout) {
            clearTimeout(window._toolTimeout);
            window._toolTimeout = null;
          }
          if (window._switchTooltip) {
            clearTimeout(window._switchTooltip);
            window._switchTooltip = null;
          }

          window._toolTimeout = setTimeout(function () {
            _this.showTools($target);
          }, 100);

          // This section supports the child element's tool overlapping the parent tool
          window._switchTooltip = setTimeout(function () {
            const $childMERs = $target.find('.element-wrap, .module-wrap, .gf_row');
            if ($childMERs.length > 0) {
              const x = e.clientX;
              const y = e.clientY;

              $childMERs.each(function (index, el) {
                const $el = jQuery(el);
                const $toolbar = jQuery(el).children('.gf-tool');
                const width = $toolbar.width();
                const height = $toolbar.height();
                const offset = $toolbar.offset();

                if (
                  offset &&
                  offset.left <= x &&
                  x <= offset.left + width &&
                  offset.top <= y &&
                  y <= offset.top + height
                ) {
                  if ($target.data('gfrow')) {
                    $target.data('gfrow').hideTool();
                  } else if ($target.data('gfmodule')) {
                    $target.data('gfmodule').hideTool();
                  } else if ($target.data('gfelement')) {
                    $target.data('gfelement').hideTool();
                  }

                  if ($el.data('gfrow')) {
                    $el.data('gfrow').showTool();
                  } else if ($el.data('gfmodule')) {
                    $el.data('gfmodule').showTool();
                  } else if ($el.data('gfelement')) {
                    $el.data('gfelement').showTool();
                  }

                  $el.addClass('gf_primary-tool');

                  return false;
                }
              });
            }
          }, 2000);
        }

        $gryffEditor.off('handleshortcut.element').on('handleshortcut.element', function (elm, data) {
          const $target = jQuery(e.target);
          _this.handleShortcutTargetElm($target, data);
          return false;
        });
        // return false;
      });

      $element.off('mouseleave.tool').on('mouseleave.tool', function (e) {
        if (window._toolTimeout) {
          clearTimeout(window._toolTimeout);
          window._toolTimeout = null;
        }
        if (window._switchTooltip) {
          clearTimeout(window._switchTooltip);
          window._switchTooltip = null;
        }
      });

      $element.off('mousedown.settings').on('mousedown.settings', function (e) {
        if (e.which !== 3) {
          const doMouseDownSettings = () => {
            $_targetMER = jQuery(e.target).closest('.gf_row, .module-wrap, .element-wrap');

            if ($_targetMER.hasClass('gf_row_no_tools')) {
              return;
            }

            //support actions
            //đang ở chế độ select target
            if (store.getValue('__selectingTarget') == 1) {
              const $merParent = jQuery(e.target).parents('.gf_row, .element-wrap, .module-wrap').first();
              $merParent.trigger('click.select-target');
              return;
            }

            const $checkOutline = jQuery(e.target).closest('.gf-outline');
            const $checkAddContentBtn = jQuery(e.target).closest('.gf_add-content-span');

            if ($_targetMER.length > 0 && $checkOutline.length == 0 && $checkAddContentBtn.length == 0) {
              const $checkTool = jQuery(e.target).closest('.gf-tool');

              if ($checkTool.length === 0) {
                $gryffBody.data('gftools').showTools($_targetMER);

                if ($_targetMER.data('gfelement') != undefined) {
                  $_targetMER.data('gfelement').openElementSettings();
                } else if ($_targetMER.data('gfmodule') != undefined) {
                  // Except Next / Prev button of Carousel
                  if (jQuery(e.target).closest('.owl-nav').length == 0) {
                    $_targetMER.data('gfmodule').openModuleSettings();
                  }
                } else if ($_targetMER.data('gfrow') != undefined) {
                  $_targetMER.data('gfrow').openRowSettings();
                }
              }
            } else if ($checkAddContentBtn.length > 0) {
              $checkAddContentBtn.addClass('active');
              setTimeout(function () {
                $checkAddContentBtn.removeClass('active');
              }, 100);

              $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);

              // Add to gfCount
              const extraCount = {};
              if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                $gryffEditor.data('gfcount').add('back-to-snippets-drop-elm', extraCount);
              }

              const $hightlight = jQuery('<div class="gf_panel-hightlight-all element-panel"></div>');
              $gfLeftSideBar.find('.side-panels').append($hightlight);
              setTimeout(function () {
                $hightlight.remove();
              }, 1000);
            }
          };
          doMouseDownSettings();
        }
      });
    }),
      // gfTools.showTool
      (this.showTools = function ($target) {
        window._showToolList = [];
        window._hideToolList = [];

        // product module
        if (
          ($target.attr('data-label') == 'Product' && $target.closest('[data-label="Product List"]').length > 0) ||
          ($target.attr('data-label') == 'Product' && $target.closest('[data-label="Related Products"]').length > 0) ||
          ($target.attr('data-label') == 'Article' && $target.closest('[data-label="Article List"]').length > 0)
        ) {
          window._hideToolList.push($target);
        } else {
          window._showToolList.push($target);
        }

        const $parentRow = $target.parent().closest('.gf_row');
        const $parentModule = $target.parent().closest('.module-wrap');

        let $topParent = $target;

        $target.parents().each(function () {
          if (jQuery(this).hasClass('gf_row') || jQuery(this).hasClass('module-wrap')) {
            // product module
            if (
              (jQuery(this).attr('data-label') == 'Product' &&
                jQuery(this).closest('[data-label="Product List"]').length > 0) ||
              (jQuery(this).attr('data-label') == 'Product' &&
                jQuery(this).closest('[data-label="Related Products"]').length > 0) ||
              (jQuery(this).attr('data-label') == 'Article' &&
                jQuery(this).closest('[data-label="Article List"]').length > 0)
            ) {
              window._hideToolList.push(jQuery(this));
            } else {
              if (
                jQuery(this).parent().hasClass('gryffeditor') ||
                jQuery(this).is($parentRow) ||
                jQuery(this).is($parentModule)
              ) {
                window._showToolList.push(jQuery(this));
                $topParent = jQuery(this);
              } else {
                if (
                  jQuery(this).attr('data-label') == 'Product List' ||
                  jQuery(this).attr('data-label') == 'Related Products' ||
                  jQuery(this).attr('data-label') == 'Article List'
                ) {
                  window._showToolList.push(jQuery(this));
                } else {
                  window._hideToolList.push(jQuery(this));
                }
              }
            }
          }
        });

        /* show tool list */
        for (var i = 0; i < window._showToolList.length; i++) {
          var $object;
          if ($topParent.is(window._showToolList[i])) {
            $object = $topParent;
          } else {
            $object = window._showToolList[i];
          }
          if ($object.data('gfrow') != undefined) {
            $object.data('gfrow').showTool();
          } else if ($object.data('gfmodule') != undefined) {
            $object.data('gfmodule').showTool();
          } else if ($object.data('gfelement') != undefined) {
            $object.data('gfelement').showTool();
          }
        }
        /* hide tool list */
        for (var i = 0; i < window._hideToolList.length; i++) {
          var $object = window._hideToolList[i];
          if ($object.data('gfrow') != undefined) {
            $object.data('gfrow').hideTool();
          } else if ($object.data('gfmodule') != undefined) {
            $object.data('gfmodule').hideTool();
          } else if ($object.data('gfelement') != undefined) {
            $object.data('gfelement').hideTool();
          }
        }
      });

    this.handleShortcutTargetElm = function ($target, key) {
      // Check
      if ($target.closest('.gf_row, .module-wrap, .element-wrap').length == 0) {
        return false;
      }
      let $targetElm = $target;
      if (!$target.hasClass('element-wrap')) {
        $targetElm = $target.closest('.element-wrap');
      }
      if ($targetElm.length == 0 && (!$target.hasClass('gf_row') || !$target.hasClass('module-wrap'))) {
        $target.parents().each(function () {
          if (jQuery(this).hasClass('gf_row') || jQuery(this).hasClass('module-wrap')) {
            $targetElm = jQuery(this);
            return false;
          }
        });
      }
      // Handle
      if ($targetElm.hasClass('element-wrap')) {
        switch (key) {
          case 'COPY_CSS':
            $targetElm.data('gfelement').copyCSS();
            break;
          case 'PASTE_CSS':
            $targetElm.data('gfelement').pasteCSS();
            break;
          case 'CLONE':
            $targetElm.data('gfelement').cloneMe();
            break;
          case 'DELETE':
            const textIsEditing = $targetElm.find('.text-editing').length > 0;
            if (textIsEditing) {
              return;
            }
            $targetElm.data('gfelement').doRemoveMe();
            $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
            break;
        }
      } else if ($targetElm.hasClass('module-wrap')) {
        if ($targetElm.data('gfmodule') !== undefined) {
          switch (key) {
            case 'COPY_CSS':
              $targetElm.data('gfmodule').copyCSS();
              break;
            case 'PASTE_CSS':
              $targetElm.data('gfmodule').pasteCSS();
              break;
            case 'CLONE':
              $targetElm.data('gfmodule').cloneMe();
              break;
            case 'DELETE':
              $targetElm.data('gfmodule').doRemoveMe();
              $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
              break;
          }
        }
      } else if ($targetElm.hasClass('gf_column')) {
        const $row = $targetElm.parent();
        if ($row.data('gfrow') !== undefined) {
          switch (key) {
            case 'CLONE':
              $row.data('gfrow').cloneMe();
              break;
            case 'DELETE':
              $row.data('gfrow').doRemoveMe();
              $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
              break;
          }
        }
      } else if ($targetElm.hasClass('gf_row')) {
        if ($targetElm.data('gfrow') !== undefined) {
          switch (key) {
            case 'COPY_CSS':
              $targetElm.data('gfrow').copyCSS();
              break;
            case 'PASTE_CSS':
              $targetElm.data('gfrow').pasteCSS();
              break;
            case 'CLONE':
              $targetElm.data('gfrow').cloneMe();
              break;
            case 'DELETE':
              $targetElm.data('gfrow').doRemoveMe();
              $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
              break;
          }
        }
      } else {
        return false;
      }
    };

    this.init();
  };

  jQuery.fn.gfTools = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gftools')) {
        const plugin = new jQuery.gfTools(this, options);
        jQuery(this).data('gftools', plugin);
      }
    });
  };
})(jQuery);
